// Mock data for books - will be replaced with real API data later

export const mockBooks = [
  {
    id: '1',
    title: 'The Midnight Library',
    author: 'Matt Haig',
    coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80',
    rating: 4.5,
    description: 'Between life and death there is a library, and within that library, the shelves go on forever. Every book provides a chance to try another life you could have lived.',
    genres: ['Fiction', 'Fantasy', 'Philosophy'],
    publishYear: 2020,
    pages: 304,
    featured: true,
    samplePages: [
      { page: 1, content: 'Nineteen years before she decided not to die, Nora Seed sat in the warmth of the school library...' },
      { page: 2, content: 'The library was a place of safety. A refuge. A world within a world...' },
      { page: 3, content: 'She had always loved books. They were portals to other lives, other possibilities...' }
    ]
  },
  {
    id: '2',
    title: 'Atomic Habits',
    author: 'James Clear',
    coverImage: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=400&q=80',
    rating: 4.8,
    description: 'An Easy & Proven Way to Build Good Habits & Break Bad Ones. Transform your life with tiny changes that deliver remarkable results.',
    genres: ['Self-Help', 'Non-Fiction', 'Psychology'],
    publishYear: 2018,
    pages: 320,
    featured: false,
    samplePages: [
      { page: 1, content: 'Changes that seem small and unimportant at first will compound into remarkable results...' }
    ]
  },
  {
    id: '3',
    title: 'Project Hail Mary',
    author: 'Andy Weir',
    coverImage: 'https://images.unsplash.com/photo-1614544048536-0d28caf77f41?w=400&q=80',
    rating: 4.7,
    description: 'A lone astronaut must save the earth from disaster in this incredible new science-based thriller from the author of The Martian.',
    genres: ['Science Fiction', 'Thriller', 'Adventure'],
    publishYear: 2021,
    pages: 496,
    featured: false,
    samplePages: []
  },
  {
    id: '4',
    title: 'The Silent Patient',
    author: 'Alex Michaelides',
    coverImage: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=400&q=80',
    rating: 4.6,
    description: 'A shocking psychological thriller about a woman who shoots her husband and then never speaks another word.',
    genres: ['Mystery', 'Thriller', 'Psychological'],
    publishYear: 2019,
    pages: 336,
    featured: false,
    samplePages: []
  },
  {
    id: '5',
    title: 'Educated',
    author: 'Tara Westover',
    coverImage: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&q=80',
    rating: 4.7,
    description: 'A memoir about a young girl who leaves her survivalist family and goes on to earn a PhD from Cambridge University.',
    genres: ['Memoir', 'Non-Fiction', 'Biography'],
    publishYear: 2018,
    pages: 334,
    featured: false,
    samplePages: []
  },
  {
    id: '6',
    title: 'Where the Crawdads Sing',
    author: 'Delia Owens',
    coverImage: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=400&q=80',
    rating: 4.5,
    description: 'A story of a young woman who raised herself in the marshes of North Carolina and becomes a suspect in a murder.',
    genres: ['Fiction', 'Mystery', 'Romance'],
    publishYear: 2018,
    pages: 384,
    featured: false,
    samplePages: []
  },
  {
    id: '7',
    title: 'Sapiens',
    author: 'Yuval Noah Harari',
    coverImage: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=400&q=80',
    rating: 4.6,
    description: 'A brief history of humankind exploring how Homo sapiens came to dominate the world.',
    genres: ['History', 'Non-Fiction', 'Science'],
    publishYear: 2011,
    pages: 443,
    featured: false,
    samplePages: []
  },
  {
    id: '8',
    title: 'The Seven Husbands of Evelyn Hugo',
    author: 'Taylor Jenkins Reid',
    coverImage: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=400&q=80',
    rating: 4.7,
    description: 'Aging Hollywood icon Evelyn Hugo finally tells the truth about her glamorous and scandalous life.',
    genres: ['Fiction', 'Romance', 'Historical'],
    publishYear: 2017,
    pages: 400,
    featured: false,
    samplePages: []
  },
  {
    id: '9',
    title: 'Dune',
    author: 'Frank Herbert',
    coverImage: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=400&q=80',
    rating: 4.8,
    description: 'Set on the desert planet Arrakis, this is the story of Paul Atreides and his journey to avenge his family.',
    genres: ['Science Fiction', 'Fantasy', 'Adventure'],
    publishYear: 1965,
    pages: 688,
    featured: false,
    samplePages: []
  },
  {
    id: '10',
    title: 'The Psychology of Money',
    author: 'Morgan Housel',
    coverImage: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=400&q=80',
    rating: 4.6,
    description: 'Timeless lessons on wealth, greed, and happiness exploring the strange ways people think about money.',
    genres: ['Finance', 'Non-Fiction', 'Self-Help'],
    publishYear: 2020,
    pages: 256,
    featured: false,
    samplePages: []
  }
];

export const mockCategories = [
  {
    id: 'bestsellers',
    title: 'Bestsellers',
    books: mockBooks.slice(0, 6)
  },
  {
    id: 'fiction',
    title: 'Fiction Favorites',
    books: mockBooks.filter(b => b.genres.includes('Fiction'))
  },
  {
    id: 'nonfiction',
    title: 'Non-Fiction Must Reads',
    books: mockBooks.filter(b => b.genres.includes('Non-Fiction'))
  },
  {
    id: 'scifi',
    title: 'Science Fiction & Fantasy',
    books: mockBooks.filter(b => b.genres.includes('Science Fiction') || b.genres.includes('Fantasy'))
  },
  {
    id: 'mystery',
    title: 'Mystery & Thriller',
    books: mockBooks.filter(b => b.genres.includes('Mystery') || b.genres.includes('Thriller'))
  }
];

export const mockAds = [
  {
    id: 'ad1',
    title: 'Featured Author Spotlight',
    description: 'Discover new releases from award-winning authors',
    image: 'https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=800&q=80',
    link: '#'
  },
  {
    id: 'ad2',
    title: 'Summer Reading Challenge',
    description: 'Join our community and read 10 books this summer',
    image: 'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=800&q=80',
    link: '#'
  }
];

export const getFeaturedBook = () => mockBooks.find(b => b.featured) || mockBooks[0];
export const getBookById = (id) => mockBooks.find(b => b.id === id);
export const searchBooks = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return mockBooks.filter(b => 
    b.title.toLowerCase().includes(lowercaseQuery) || 
    b.author.toLowerCase().includes(lowercaseQuery) ||
    b.genres.some(g => g.toLowerCase().includes(lowercaseQuery))
  );
};